import { useQuery } from 'react-query'
import { axios } from '../../../lib'

type LoadCitiesParams = {
  stateId?: string
  page?: number
  limit?: number
}

export const loadCities = (query: LoadCitiesParams): Promise<any> => {
  const { stateId, page = 1, limit = 10000, ...rest } = query

  return axios.get(`orders/generals/states/${stateId}/cities`, {
    params: {
      page,
      limit,
      ...rest
    }
  })
}

export function useLoadCities(query: LoadCitiesParams) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['cities', query],
    () => loadCities(query),
    {
      enabled: !!query?.stateId
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
